import { HttpService } from '@/data/http/http-service';
import { VenueMonthDeclaration } from '@/domain/project-venue-month-declaration/entities/project-venue-month-declaration';
import { ProjectVenueMonthDeclarationGateway } from '@/domain/project-venue-month-declaration/gateways/project-venue-month-declaration.gateway';

import { getMonthDeclarationsDtoSchema } from './dto.schema';
import { MonthDeclarationsMapper } from './mapper';

export class ApiProjectVenueMonthDeclarationHttpGateway implements ProjectVenueMonthDeclarationGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_PROJECT,
  });

  async submitMonthDeclaration(
    projectId: number,
    monthKey: string, // format 2024-01
    monthDeclaration: VenueMonthDeclaration,
    submitMode: 'create' | 'edit',
  ): Promise<void> {
    let url = '';
    if (submitMode === 'create') {
      url = `/seasons/${projectId}/month-declaration`;
    } else if (submitMode === 'edit') {
      url = `/seasons/${projectId}/month-declaration/${monthDeclaration.id}`;
    }
    const data = MonthDeclarationsMapper.entityToDto(
      monthDeclaration,
      monthKey,
    );
    let response;
    if (submitMode === 'create') {
      response = await this.http.post(url, data);
    } else if (submitMode === 'edit') {
      response = await this.http.patch(url, data);
    }
    if (response && (response.status === 201 || response.status === 200)) {
      return;
    } else {
      throw 'error on submit';
    }
  }

  async getMonthDeclarations(projectId: number): Promise<{
    [monthKey: string]: VenueMonthDeclaration;
  }> {
    const url = `/seasons/${projectId}/month-declaration`;
    const options = { params: { $limit: 1000 } };
    const response = await this.http.get(url, options);
    const result = getMonthDeclarationsDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const monthDeclarations = MonthDeclarationsMapper.dtoToEntity(
      result.data.data,
    );
    return monthDeclarations;
  }
}
